<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { tooltip } from '@svelte-plugins/tooltips';
    import VehicleLimitTooltip from './VehicleLimitTooltip.svelte';
    import { type VehicleLimitExceededType } from './VehicleLimit/VehicleLimitItem';

    export let limit: VehicleLimitExceededType;
    export let hasNonNormativeOrders: boolean = false;

    let valueToUse: number;
    let altWithValues: string;
    let src: string;

    $: {
        src = 'data:image/svg+xml;base64,' + btoa(limit.src.replace(/\{color\}/g, limit.color));
        valueToUse = limit.maxValue && limit.value < limit.limit ? limit.maxValue : limit.value;
        altWithValues = $_(limit.alt, { values: { limit: limit.limit, value: valueToUse } });
    }
    //     use:tooltip={{content: {component: VehicleLimitTooltip, props: {alerts: [limit], values: true, percent: true, units: true, hasNonNormativeOrders: hasNonNormativeOrders}}, theme: 'lastmile-tooltip-no-events', maxWidth: 400}}

</script>

<span
    class="container"
    style="box-sizing: border-box;"
    data-value={limit.value}
    data-limit={limit.limit}
    data-color={limit.color}
>
    <img
        {src}
        alt={altWithValues}
    />
</span>

<style>
    .container {
        display: inline-block;
        /*padding-left: 3px;*/
    }
    .container img {
        vertical-align: middle;
        max-height: 16px;
    }
</style>
